import React from 'react';
import { Download, FileDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DownloadExcelProps {
  onDownload: () => void;
}

const DownloadExcel: React.FC<DownloadExcelProps> = ({onDownload}) => {
    const { t } = useTranslation();
  
  return (
    <button
      onClick={onDownload}
      className="group relative flex items-center justify-center p-1.5 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 hover:scale-105 hover:opacity-90 focus:outline-none focus:ring-2 overflow-hidden bg-white"
      style={{ border: '2px solid var(--color-primary)' }}
      title={t('report.downloadExcel')}
    >
      <Download size={14} strokeWidth={2.5} style={{ color: 'var(--color-primary)' }} />
    </button>
  );
};

export default DownloadExcel;
